import { Link } from "react-router-dom";
import { PageLayout, PageBody } from "@/components/site/PageLayout";
import { GIFT_IMAGE } from "@/data/services";

export default function GiftsPage() {
  return (
    <PageLayout eyebrow="Gift Certificates" title="Give the gift of a" titleAccent="clean ride">
      <PageBody>
        <img
          src={GIFT_IMAGE}
          alt="Brad's Mobile Detailing gift certificate"
          data-testid="gifts-certificate-image"
          className="w-full max-w-3xl border border-[#232329]"
        />
        <p className="mt-8 max-w-3xl text-base text-slate-300 leading-relaxed">
          Give the gift of a clean and shiny ride to that special person on your list! We provide
          gift certificates for all occasions and you can select a specific detailing{" "}
          <Link to="/packages" className="text-[#FF4311] hover:underline">Package</Link> or choose a
          cash value. Simply fill out the form and we will send you or the lucky person their
          customized gift certificate to be redeemed whenever they like! You can print it out, email
          it yourself, or have us deliver it at a specific time to the recipient's email address.
        </p>

        <div className="mt-8 bg-[#121216] border border-[#232329] p-7 md:p-10 max-w-3xl">
          <h2 className="font-display uppercase text-xl tracking-wide text-white">Order by Phone</h2>
          <p className="mt-3 text-sm text-slate-300 leading-relaxed">
            Give us a quick call to purchase your gift certificate — pick a package or any dollar
            amount, and we'll set it up and send it to you or the lucky person.
          </p>
          <a
            href="tel:+19803588323"
            data-testid="gifts-call-button"
            className="mt-6 inline-flex items-center justify-center bg-[#EA0A0B] hover:bg-[#C20A0B] text-white font-display uppercase tracking-[0.12em] text-sm px-10 py-4 transition-colors"
          >
            Call (980) 358-8323
          </a>
          <p className="mt-6 text-sm text-slate-400">
            Prefer to order by message?{" "}
            <Link to="/contact-us" className="text-[#FF4311] hover:underline">Contact us</Link> and
            we'll set up your gift certificate.
          </p>
        </div>
      </PageBody>
    </PageLayout>
  );
}
